import { render } from "./new-version-auth.vue?vue&type=template&id=74348755"
import script from "./new-version-auth.vue?vue&type=script&lang=js"
export * from "./new-version-auth.vue?vue&type=script&lang=js"

import "./new-version-auth.vue?vue&type=style&index=0&id=74348755&lang=css"

import exportComponent from "/var/www/vistream-spa-cp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__